var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sms-confirm" },
    [
      _c(
        "form-item",
        {
          staticClass: "sms-confirm__form-item",
          attrs: {
            label: "Код подтверждения",
            "text-after": "На указанный вами номер отправлен код",
            "is-bold-label": true,
            "text-error": _vm.errorSendReceivedCode
          }
        },
        [
          _c("input-control", {
            attrs: { inputmode: "tel" },
            model: {
              value: _vm.value,
              callback: function($$v) {
                _vm.value = $$v
              },
              expression: "value"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "form-item",
        { staticClass: "sms-confirm__form-item" },
        [
          _c(
            "button-control",
            {
              attrs: { loading: _vm.isSendingCode, "is-block": true },
              on: { click: _vm.sendReceivedCodeMethod }
            },
            [_vm._v("\n      Отправить\n    ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "form-item",
        { staticClass: "sms-confirm__form-item no-mb" },
        [
          _c("vue-countdown", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isMaySendAnotherCode,
                expression: "!isMaySendAnotherCode"
              }
            ],
            ref: "countdown",
            staticClass: "sms-confirm__countdown",
            attrs: { time: Number(_vm.timeLeft), "auto-start": false },
            on: {
              end: function($event) {
                _vm.isMaySendAnotherCode = true
              }
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return [
                    _vm._v(
                      "\n        Отправить код повторно можно через:\n        " +
                        _vm._s(props.minutes) +
                        "\n        " +
                        _vm._s(
                          _vm._f("plural")(props.minutes, [
                            "минута",
                            "минуты",
                            "минут"
                          ])
                        ) +
                        ",\n        " +
                        _vm._s(props.seconds) +
                        "\n        " +
                        _vm._s(
                          _vm._f("plural")(props.seconds, [
                            "секунда",
                            "секунды",
                            "секунд"
                          ])
                        ) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _vm.isMaySendAnotherCode
            ? _c(
                "button",
                {
                  staticClass: "link _dashed",
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.sendCode($event)
                    }
                  }
                },
                [_vm._v("\n      Отправить код повторно\n    ")]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }